// src/api/empresa.js
import { apiFetch } from './index.js';

/**
 * Obtiene la lista de todas las empresas
 */
export const obtenerEmpresas = async () => {
  try {
    const response = await apiFetch('/api/Empresa/listar');
    const data = Array.isArray(response) ? response : (response.data || []);
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener empresas:', error);
    return { 
      success: false, 
      error: error.message || 'Error al cargar las empresas',
      data: []
    };
  }
};

/**
 * Crea una nueva empresa
 */
export const crearEmpresa = async (empresaData) => {
  try {
    const response = await apiFetch('/api/Empresa/crear', {
      method: 'POST',
      body: {
        tenantId: empresaData.tenantId,
        nombreEmpresa: empresaData.nombreEmpresa,
        administrador: empresaData.administrador,
        fechaVencimientoMantenimiento: empresaData.fechaVencimientoMantenimiento,
        precioMantenimientoUsd: empresaData.precioMantenimientoUsd,
        config: empresaData.config,
        logoBase64: empresaData.logoBase64,
        faviconBase64: empresaData.faviconBase64
      }
    });
    return { success: true, data: response, message: 'Empresa creada exitosamente' };
  } catch (error) {
    console.error('Error al crear empresa:', error);
    return { 
      success: false, 
      error: error.message || 'Error al crear la empresa'
    };
  }
};

/**
 * Cambia el estado activo/inactivo de una empresa
 */
export const cambiarEstadoEmpresa = async (tenantId, activo) => {
  try {
    const response = await apiFetch('/api/Empresa/cambiar', {
      method: 'POST',
      body: { tenantId, activo }
    });
    return { success: true, data: response, message: 'Estado actualizado' };
  } catch (error) {
    console.error('Error al cambiar estado de empresa:', error);
    return { 
      success: false, 
      error: error.message || 'Error al cambiar el estado'
    };
  }
};

/**
 * Elimina una empresa (solo Super Admin)
 */
export const eliminarEmpresa = async (tenantId) => {
  try {
    await apiFetch(`/api/Empresa/eliminar/${tenantId}`, {
      method: 'DELETE'
    });
    return { success: true, message: 'Empresa eliminada' };
  } catch (error) {
    console.error('Error al eliminar empresa:', error);
    return { 
      success: false, 
      error: error.message || 'Error al eliminar la empresa'
    };
  }
};

/**
 * Obtiene una empresa por ID
 */
export const obtenerEmpresaPorId = async (tenantId) => {
  try {
    const response = await apiFetch(`/api/Empresa/${tenantId}`);
    return { success: true, data: response };
  } catch (error) {
    console.error('Error al obtener empresa:', error);
    return { 
      success: false, 
      error: error.message || 'Error al obtener la empresa'
    };
  }
};

// =====================================================
// 👈 NUEVO: CONFIGURACIÓN VISUAL DEL TENANT
// Guarda el logo y la info en public/tenants/<id>/
// =====================================================

/**
 * Obtiene la configuración visual de una empresa
 * @param {string} tenantId - ID del tenant
 */
export const obtenerConfigEmpresa = async (tenantId) => {
  try {
    const res = await apiFetch(`/api/Empresa/${tenantId}/config`);
    return { success: true, data: res.data || res };
  } catch (error) {
    console.error('Error obteniendo config de empresa:', error);
    return { success: false, error: error.message, data: null };
  }
};

/**
 * Guarda la configuración visual de una empresa
 * @param {string} tenantId - ID del tenant
 * @param {Object} config - Datos de la empresa (nombre, rif, dirección, etc)
 * @param {string} logoBase64 - Logo en base64
 * @param {string} faviconBase64 - Favicon en base64
 */
export const guardarConfigEmpresa = async (tenantId, config, logoBase64 = null, faviconBase64 = null) => {
  try {
    const res = await apiFetch(`/api/Empresa/${tenantId}/config`, {
      method: 'POST',
      body: {
        config,
        logoBase64,
        faviconBase64
      }
    });
    return { success: true, data: res, message: 'Configuración guardada' };
  } catch (error) {
    console.error('Error guardando config de empresa:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Elimina la configuración visual de una empresa
 * @param {string} tenantId - ID del tenant
 */
export const eliminarConfigEmpresa = async (tenantId) => {
  try {
    const res = await apiFetch(`/api/Empresa/${tenantId}/config`, {
      method: 'DELETE'
    });
    return { success: true, data: res, message: 'Configuración eliminada' };
  } catch (error) {
    console.error('Error eliminando config de empresa:', error);
    return { success: false, error: error.message };
  }
};